<template>
<!--  <bk-page class="KISIndexPage">-->
    <bk-view class="view-kisWeb">

      <transition name="rightFadeIn" mode="out-in">
        <component :is="showPage" :anchors="anchors" @bookBtnClick="bookBtnClick"/>
      </transition>

    </bk-view>
<!--  </bk-page>-->
</template>

<script>

	import KisHome from './kisHome/kisHome.vue';
	import SalonPriceList from './salonPriceList/salonPriceList.vue';
	import KisProducts from './kisProducts/kisProducts.vue';

	export default {
		name: 'KISWeb',
		props:{
			anchors: String, // about  gallery product
			// showPage: 'KisHome',
			showPage: {
				type: String,
				default: 'KisHome',
			},
		},
		components: {
			KisHome, SalonPriceList, Products: KisProducts,
		},
		computed: {},
		data () {
			return {
				iframeUrl: 'https://www.kishair.com.au/',

				showResFlag: false,
			};
		},
		async created () {
		},
		methods: {
			bookBtnClick () {
				console.log(1231231, '预约');
				this.$emit('bookBtnClick');
			}
		}
	};
</script>

<style lang="less">

.view-kisWeb {
  overflow-y: auto;
  height: 100%;
  background: #fff;

  > .view-iframe {
    width: 100%;
    height: 100%;

    > iframe {
      display: block;
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
    }
  }
}

</style>